import { useTracker, ZigzagEvent } from '@common/log-manager';

const getUrl = () => {
  return typeof window !== 'undefined' ? window.location.href : null;
};
export const useShopLog = () => {
  const tracker = useTracker();

  const clickStore = (catalog_product_id: string, shop_id: string) => {
    ZigzagEvent.subl({
      category: 'click',
      navigation: 'product_detail',
      object_section: 'store_info',
      object_type: 'button',
      object_id: 'shop_home',
      data: JSON.stringify({
        catalog_product_id,
        shop_id,
      }),
    });
  };

  const clickStory = (shop_id: string) => {
    ZigzagEvent.subl({
      category: 'click',
      navigation: 'product_detail',
      object_type: 'media',
      object_id: shop_id,
      data: JSON.stringify({ view_type: 'story' }),
    });
  };

  const impressionStory = (catalog_product_id: string, shop_id: string) => {
    ZigzagEvent.subl({
      category: 'impression',
      navigation: 'product_detail',
      object_type: 'media',
      object_id: shop_id,
      data: JSON.stringify({ catalog_product_id, view_type: 'story' }),
    });
  };

  const clickStoreHome = async (catalog_product_id: string, shop_id: string) => {
    await tracker.sendImmediately({
      category: 'click',
      navigation: 'product_detail',
      navigation_sub: {
        page_url: getUrl(),
      },
      object_section: 'store_info',
      object_type: 'button',
      object_id: shop_id,
      data: { catalog_product_id },
    });
  };

  return {
    clickStore,
    clickStory,
    clickStoreHome,
    impressionStory,
  };
};
